import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { BRAND } from "@/lib/brand";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(form.email, form.password);
      nav(u.role === "admin" ? "/admin" : "/account");
    } catch (err) { setError(apiError(err.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-20">
      <div className="text-center mb-8">
        <img src={BRAND.logoCircle} alt="APE-TIDES" className="h-20 w-20 object-contain mx-auto mb-4" />
        <h1 className="font-display text-4xl tracking-tight">WELCOME BACK</h1>
        <p className="text-ape-muted text-sm mt-2">Log in to fuel your evolution.</p>
      </div>
      <form onSubmit={submit} className="border border-ape-border bg-ape-surface p-8 space-y-6" data-testid="login-form">
        {error && <div className="border border-ape-red bg-ape-red/10 text-ape-red text-sm p-3 font-mono2" data-testid="login-error">{error}</div>}
        <label className="block">
          <span className="font-mono2 text-[10px] tracking-widest text-ape-muted">EMAIL</span>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email"
            className="w-full bg-transparent border-b-2 border-ape-border rounded-none py-2 text-white focus:border-ape-red focus:outline-none transition-colors duration-150" />
        </label>
        <label className="block">
          <span className="font-mono2 text-[10px] tracking-widest text-ape-muted">PASSWORD</span>
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password"
            className="w-full bg-transparent border-b-2 border-ape-border rounded-none py-2 text-white focus:border-ape-red focus:outline-none transition-colors duration-150" />
        </label>
        <button disabled={loading} className="w-full bg-ape-red hover:bg-ape-redhover disabled:opacity-50 text-white font-head uppercase tracking-widest py-4 transition-colors duration-150" data-testid="login-submit">
          {loading ? "Logging in..." : "Log In"}
        </button>
        <Link to="/forgot-password" className="block text-center font-mono2 text-xs tracking-widest text-ape-muted hover:text-ape-red transition-colors duration-150" data-testid="forgot-password-link">
          FORGOT PASSWORD?
        </Link>
      </form>
      <p className="text-center text-ape-muted text-sm mt-6">No account? <Link to="/register" className="text-ape-red hover:text-white transition-colors duration-150" data-testid="to-register">Create one</Link></p>
    </div>
  );
}
